<div>
    <div style="margin-left: 80%;  margin-bottom: 2%;">
        <button class="noPrint" style="margin-top: 2% 2% 0 2%;" (click)="excelToExportPostingLabel('Posting_Label_And_Statement_Report')"
        mat-raised-button color="primary">
        Export
      </button>
        <!-- <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;"
            mat-raised-button color="primary" printTitle="Label" printSectionId="print-section" ngxPrint
              (click)="printPage()">
            Print
        </button> -->
        <button class="noPrint"
        style="margin-top: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()" printSectionId="print-section">
         Print
       </button>
      
        <button mat-dialog-close class="btn noPrint" style=" z-index: 10">Close</button>
    </div>
    <div class="container" id="print-section">
        <ng-container *ngFor="let group of groupedData">
            <table class="table table-bordered" style="border-collapse: collapse; width: 100%;">
                <thead>
                    <tr>
                        <th colspan="5" style="font-size: 14px;">
                            <span style="margin-right: 50px;">दिनांक: {{ currentDate | date:'dd/MM/yyyy HH:mm:ss' }}</span>  
                            हिंदुस्थान प्रकाशन संस्था विवेक साप्ताहिक
                        </th>
                    </tr>
                    <tr>
                        <!-- <th colspan="6" style="font-size: 14px;">
                            <span style="margin-right: 480px;">पृष्ठ क्र:</span>  
                            नोंदणीदार - प्रतिनिधी व कार्यालयीन वर्गणी {{rep_name?group.rep_name: ''}} -
                            {{office_rep_name?group.office_rep_name: ''}} वर्गणी जमा असलेले
                        </th> -->
                        <th colspan="5" style="font-size: 14px;">
                            <span style="margin-right: 480px;">पृष्ठ क्र:</span>
                            <span *ngIf="(group.rep_name && group.rep_name.trim() !== '') || (group.office_rep_name && group.office_rep_name.trim() !== ''); else defaultText">
                                नोंदणीदार -  प्रतिनिधी - {{ rep_name?group.rep_name: '' }} व कार्यालयीन वर्गणी - {{ office_rep_name?group.office_rep_name: '' }} -  वर्गणी जमा असलेले
                            </span>
                            <ng-template #defaultText>
                                नोंदणीदार - प्रतिनिधी व कार्यालयीन वर्गणी
                            </ng-template>
                        </th>
                    </tr>
                    <tr>
                        <th colspan="5" style="font-size: 14px;">
                            <span style="margin-right: 110px;">वितरण -  {{ delivery_mode?group.delivery_mode: ''}}</span>  
                            <span style="margin-right: 232px;">{{ country?group.country:'' }} - {{ state?group.state:'' }} - {{ district?group.district:'' }} - {{ taluka?group.taluka:'' }}</span>
                            <span style="margin-right: 240px;">वर्गणी - वर्गणी जमा असलेले</span>  
                            वितरण सांकेताकानुसार वर्गणीदार यादी - {{ Subscription_Type?group.Subscription_Type :''}}
                        </th>
                    </tr>
                    <tr>
                        <th style="font-size: 14px; text-align: center;">वर्गणीदार क्रमांक</th>
                        <th style="font-size: 14px; text-align: center;">वर्गणीदार नाव</th>
                        <th style="font-size: 14px; text-align: center;">पत्ता</th>
                        <!-- <th style="font-size: 14px; text-align: left;">वर्गणीदार प्रकार</th> -->
                        <th style="font-size: 14px; text-align: center;">वैध दिनांक</th>
                        <th style="font-size: 14px; text-align: center;">संपर्क</th>
                    </tr>
                </thead>
    
                <tbody>
                    <tr *ngFor="let item of group.items">
                        <td>{{ item.Subscription_Type }}{{ item.month }}/{{ item.subno }}</td>
                        <td>{{ item.title }}.{{ item.name }}</td>
                        <td>{{ item.address }} {{ item.taluka }}, {{ item.district }} {{ item.state }} {{ item.country }}, {{ item.pincode }}</td>
                        <!-- <td>{{ item.Subscription_Type }}</td> -->
                        <td>{{ item.entry_date | date:'dd/MM/yyyy' }} - {{ item.sub_perid_to_date | date:'dd/MM/yyyy' }}</td>
                        <td>{{ item.mobileNumber }}</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    </div>
    
</div>
